export enum CanCheckIn {
  Yes = 'yes',
  TooEarly = 'too early',
  TooLate = 'too late',
}
